import clsx from 'clsx';
import {useEffect, useState} from 'react';

type Props = {
  hero?: boolean;
};

export default function HeaderBackground({hero}: Props) {
  const [scrolledDown, setScrolledDown] = useState(false);

  const handleScroll = () => {
    setScrolledDown(window.scrollY > 200);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    // Trigger handler on mount to account for reloads
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={clsx(
        'pointer-events-none absolute inset-0 -z-10 bg-neutral-100/80 backdrop-blur-md',
        'transition duration-500 ease-out',
        scrolledDown || hero ? 'opacity-100' : 'opacity-0',
      )}
    />
  );
}
